function replaceUrl(): void {
  const currentUrl = new URL(window.location.href);
  const configValue = currentUrl.searchParams.get('config');
  const svValue = currentUrl.searchParams.get('sv');

  if (!configValue) return;

  currentUrl.searchParams.set('pcfg', configValue);
  window.history.replaceState({}, '', currentUrl);

  if (svValue) {
    currentUrl.searchParams.set('fscfg', `${svValue}`);
    window.history.replaceState({}, '', currentUrl);
  }
}

export default replaceUrl;
